interface IShareUploadIconProps {
  className?: string
}

const ShareUploadIcon = ({ className }: IShareUploadIconProps) => (
  <svg
    className={className}
    width="13"
    height="14"
    viewBox="0 0 13 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.12497 10.0001V3.38398L9.18303 5.44204L10.0669 4.55815L6.49997 0.991211L2.93303 4.55815L3.81691 5.44204L5.87497 3.38398V10.0001H7.12497ZM12.125 12.5001V6.87506H10.875V12.5001H2.125V6.87506H0.875V12.5001C0.875 13.1904 1.43464 13.7501 2.125 13.7501H10.875C11.5654 13.7501 12.125 13.1904 12.125 12.5001Z"
    />
  </svg>
)

export default ShareUploadIcon
